import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  importProvidersFrom,
  APP_INITIALIZER,
  ErrorHandler,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './app/lib/error-tracking/http-error.interceptor';
import { GlobalErrorHandler } from './app/lib/error-tracking/global-error.handler';
import { UnhandledPromiseRejectionHandler } from './app/lib/error-tracking/unhandled-promise-rejection.handler';

import { App } from './app/app';
import { routes } from './app/app-routing-module';
import { environment } from './environments/environment';

// Keycloak initialization function
function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'check-sso', // Verificar SSO ao invés de forçar login
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
      },
    });
}

// Initialize global error handlers
function initializeGlobalErrorHandlers(
  promiseHandler: UnhandledPromiseRejectionHandler
) {
  return () => {
    promiseHandler.initialize();
    return Promise.resolve();
  };
}

bootstrapApplication(App, {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(KeycloakAngularModule),
    // Global Error Handler
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    // HTTP Error Interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    // Initialize global error handlers
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGlobalErrorHandlers,
      multi: true,
      deps: [UnhandledPromiseRejectionHandler],
    },
    // Keycloak initialization
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
  ],
}).catch((err) => console.error(err));
